module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.woff2?745989aab0d69cab7e70bfcc96207b3d";